import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  JobBoardElementTranslations,
  JobBoardElementTranslationsToken,
} from '@recruitee/http/types';
import { I18nModule } from '@recruitee/i18n';

import { BoxModule } from '../../common/box/box.module';
import { ButtonModule } from '../../common/button/button.module';
import { HeadingModule } from '../../common/heading/heading.module';
import { RtIconHelpWithDropdownModule } from '../../common/icon-help-with-dropdown/icon-help-with-dropdown.module';
import { IconModule } from '../../common/icon/icon.module';
import { TooltipModule } from '../../common/tooltip/tooltip.module';
import { JobBoardElementComponent } from './job-board-element.component';

@NgModule({
  declarations: [JobBoardElementComponent],
  imports: [
    RouterModule,
    RtIconHelpWithDropdownModule,
    IconModule,
    HeadingModule,

    BoxModule,
    I18nModule,
    CommonModule,
    TooltipModule,
    RtIconHelpWithDropdownModule,
    ButtonModule,
  ],
  exports: [JobBoardElementComponent],
})
export class JobBoardElementModule {
  public static withTranslations(
    translations: JobBoardElementTranslations,
  ): ModuleWithProviders<JobBoardElementModule> {
    return {
      ngModule: JobBoardElementModule,
      providers: [{ provide: JobBoardElementTranslationsToken, useValue: translations }],
    };
  }
}
export * from './job-board-element.component';
